import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid, Typography } from '@material-ui/core/'
import moment from 'moment'
import { Button } from 'components/UI/'
import editMeetIcon from '../../../../../../assetss/img/editMeetIcon.svg'
import c from 'classnames'
import './index.scss'

const MeetingAvtor = ({ getChats, getMessages, setOpen, onAccept, acceptDateMeeting, ofEditIcon, title }) => {
  const [activeLink, setActiveLink] = useState(true)
  const { user } = useSelector(({ session }) => session)
  const { chatUser, meeting } = useSelector(({ chat }) => chat)
  const nowDate = moment(new Date())
  const [disabled, setDisable] = useState(false)

  const goToMeet = () => {
    if (activeLink) {
      if (meeting?.url) {
        window.open(meeting?.url)
      }
    }
  }

  useEffect(() => {
    if (chatUser?.meeting?.url) {
      if (nowDate?.diff(moment(+chatUser?.meeting?.start), 'hours') <= -1) {
        setActiveLink(false)
      }
    } else {
      setActiveLink(true)
    }
  }, [chatUser?.meeting?.url])

  useEffect(() => {
    const time = setInterval(() => {
      setDisable(!moment(new Date())?.isBefore(+chatUser?.meeting?.start))
    }, 10000)

    return () => clearInterval(time)
  }, [+chatUser?.meeting?.start])

  return (
    <Grid className='avtorDateContainerMobile'>
      <Typography className='titleMeet'>{chatUser?.status === 'scheduled' ? 'Meeting scheduled for:' : 'Suggested meeting time:'}</Typography>
      <Typography className='dateSuggested'>
        {moment(+chatUser?.meeting?.start)?.format('dddd, MMMM D')}
        {!ofEditIcon && <img onClick={() => setOpen(true)} className='editIcon' src={editMeetIcon} />}
      </Typography>
      <Typography className='timeSuggested'>
        {moment(+chatUser?.meeting?.start)?.format('LT')}
      </Typography>
      {onAccept ? (
        <Grid className='acceptBtnContainer'>
          <Button disabled={disabled} onClick={() => acceptDateMeeting('accept')} className={c('btnAccept', disabled && 'btnAcceptDisable')}>Accept</Button>
          <Button onClick={() => acceptDateMeeting('decline')} className='btnDecline'>Decline</Button>
        </Grid>
      ) : (
        <>
          <Button onClick={() => goToMeet()} className={c('btnDateSchedule', !activeLink && 'disableBtn', chatUser?.meeting?.status === 'requested' && 'disableBtn')}>
            Google Meet link
          </Button>
          {user?.user?.uuid === chatUser?.authorUuid && (
            <Button onClick={() => setOpen(true)} className='btnEditTimeMeetMobile'>
              Reschedule
            </Button>
          )}
        </>
      )}
    </Grid>
  )
}

export default MeetingAvtor
